import React, { useState } from 'react'
import { Drawer, Typography, Box, Button, TextField, MenuItem, Divider } from '@mui/material'
import { Close } from '@mui/icons-material'


const SupporterDrawer = ({ open, setOpen, selectedRowNumber, setConfirmedShifts, confirmedShifts, setEmployments, employments, generateEmploymentText, supporterEmployments}) => {
    const [selectedSupporter, setSelectedSupporter] = useState(null)
    const handleSelect = () => {
        const newEmployments = [...employments]
        const employment = newEmployments.find(e => e.row_number === selectedRowNumber)
        employment.id = selectedSupporter.id
        employment.user.id = selectedSupporter.user.id
        employment.user.name_first = '(サポート)'
        employment.user.name_last = selectedSupporter.user.name_last
        employment.user.emp_cd = selectedSupporter.user.emp_cd
        employment.text = generateEmploymentText(employment)
        setConfirmedShifts(confirmedShifts.map(shift => {
            if (shift.row_number === selectedRowNumber) {
                shift.employment_id = selectedSupporter.id
            }
            return shift
        }))
        setEmployments(newEmployments)
        setOpen(false)
    }
    return (
        <Drawer
            open={open}
            onClose={() => setOpen(false)}
            anchor="right"
            PaperProps={{
                style: {
                    width: '400px'
                }
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '90%',
                    margin: '1rem'
                }}
            >
                <Typography>不足シフトを追加</Typography>
                <Close onClick={() => setOpen(false)} />
            </div>
            <Divider />
            <Box p={2}>
                <Typography>ヘルプスタッフを選択してください。</Typography>
                <TextField
                    select
                    sx={{ width: '100%', marginTop: '1rem' }}
                    label="スタッフ"
                    value={selectedSupporter}
                    onChange={(e) => setSelectedSupporter(e.target.value)}
                    helperText={supporterEmployments.length === 0 ? 'ヘルプスタッフが登録されていません' : ''}
                    disabled={supporterEmployments.length === 0}
                >
                    {supporterEmployments.length > 0 && supporterEmployments.map(event => (
                        <MenuItem key={event.id} value={event}>{event.user.name_first} {event.user.name_last}</MenuItem>
                    ))}
                </TextField>
                <Button onClick={handleSelect} sx={{ marginTop: '1rem', width: '100%' }} variant="contained" color="primary" disabled={!selectedSupporter}>追加</Button>
            </Box>
        </Drawer>
    )
}

export default SupporterDrawer
